// extracted by mini-css-extract-plugin
export var highlightFade = "_3n-4";
export var highlighted = "_3n-3";
export var table = "_3n-1";
export var tableContainer = "_3n-0";
export var totalsRow = "_3n-2";